import React from 'react';
import { Button, Form, Input, Select, Space, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title } = Typography;

const SidebarNewContact = ({
    form,
    creatingContact,
    isMobile,
    isDarkMode,
    themeColors,
    t,
    onBack,
    onCreate
}) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0,
            overflow: 'hidden',
            padding: isMobile ? '8px 12px 0' : 0,
            backgroundColor: isDarkMode ? themeColors.cardBackground : '#FFFFFF'
        }}>
            <Space align="center" style={{ marginBottom: 12 }}>
                <Button type="text" icon={<ArrowLeftOutlined />} onClick={onBack} />
                <Title level={5} style={{ margin: 0, color: themeColors.text }}>{t('new_contact')}</Title>
            </Space>
            <div style={{
                display: 'flex', flexDirection: 'column', gap: 12, flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', paddingBottom: 12, boxSizing: 'border-box',
                paddingLeft: 5, paddingRight: 5,
            }}>
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="first_name"
                        label={t('first_name')}
                        rules={[{ required: true, message: t('please_enter_first_name') }]}
                    >
                        <Input placeholder={t('first_name')} />
                    </Form.Item>
                    <Form.Item
                        name="last_name"
                        label={t('last_name')}
                        rules={[{ required: true, message: t('please_enter_last_name') }]}
                    >
                        <Input placeholder={t('last_name')} />
                    </Form.Item>
                    <Form.Item
                        name="gender"
                        label={t('gender')}
                        rules={[{ required: true, message: t('please_select_gender') }]}
                    >
                        <Select
                            placeholder={t('gender')}
                            options={[
                                { value: 'male', label: t('male') },
                                { value: 'female', label: t('female') },
                            ]}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            block
                            loading={creatingContact}
                            onClick={onCreate}
                        >
                            {t('create')}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default SidebarNewContact;













